module.exports = __webpack_public_path__ + "img/eco7.eb231869.jpg";